var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.proDialogShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "properties" } }, [
          _c("div", { staticClass: "title" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("language.common.properties")))]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  _vm.proDialogShow = false
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "properties-cont" },
            [
              _c(
                "el-tabs",
                {
                  model: {
                    value: _vm.activeName,
                    callback: function($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: _vm.general, name: "first" } },
                    [
                      _c("div", { staticClass: "general-content" }, [
                        _c("div", { staticClass: "general-item" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("language.popup.addCloudPopup.cloudName")
                            ) +
                              ": " +
                              _vm._s(_vm.cloud.name)
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "general-item" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("language.popup.addCloudPopup.cloudType")
                            ) +
                              ": " +
                              _vm._s(
                                _vm.$t("language.addCloud." + _vm.cloudName)
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "general-item" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("language.popup.addCloudPopup.addedTime")
                            ) +
                              ": " +
                              _vm._s(
                                _vm._f("transferTime")(
                                  _vm.cloud.driveInfo.createTime
                                )
                              )
                          )
                        ]),
                        _vm._v(" "),
                        _vm.driveType != "googlePhotosV2"
                          ? _c("div", { staticClass: "general-item" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.addCloudPopup.userName"
                                  )
                                ) +
                                  ": " +
                                  _vm._s(_vm.userName)
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.driveType == "googlePhotosV2"
                          ? _c("div", { staticClass: "general-item" }, [
                              _vm._v(
                                "Google Photos Account: " + _vm._s(_vm.userName)
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.usedSpace &&
                        (_vm.driveType != "iCloudPhotos" &&
                          _vm.driveType != "iCloudDrive")
                          ? _c("div", { staticClass: "general-item" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.addCloudPopup.usedSpace"
                                  )
                                ) +
                                  ": " +
                                  _vm._s(_vm._f("formatByte")(_vm.usedSpace))
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.totalSpace &&
                        (_vm.driveType != "iCloudPhotos" &&
                          _vm.driveType != "iCloudDrive")
                          ? _c("div", { staticClass: "general-item" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.addCloudPopup.totalSpace"
                                  )
                                ) +
                                  ": " +
                                  _vm._s(_vm._f("formatByte")(_vm.totalSpace))
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.usedSpace && _vm.driveType == "iCloudPhotos"
                          ? _c("div", { staticClass: "general-item" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.addCloudPopup.iCloudUsedSpace"
                                  )
                                ) +
                                  ": " +
                                  _vm._s(_vm._f("formatByte")(_vm.usedSpace))
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.totalSpace && _vm.driveType == "iCloudPhotos"
                          ? _c("div", { staticClass: "general-item" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.addCloudPopup.iCloudTotalSpace"
                                  )
                                ) +
                                  ": " +
                                  _vm._s(_vm._f("formatByte")(_vm.totalSpace))
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.usedSpace && _vm.driveType == "iCloudDrive"
                          ? _c("div", { staticClass: "general-item" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.addCloudPopup.iCloudDriveUsedSpace"
                                  )
                                ) +
                                  ": " +
                                  _vm._s(_vm._f("formatByte")(_vm.usedSpace))
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.totalSpace && _vm.driveType == "iCloudDrive"
                          ? _c("div", { staticClass: "general-item" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.popup.addCloudPopup.iCloudDriveTotalSpace"
                                  )
                                ) +
                                  ": " +
                                  _vm._s(_vm._f("formatByte")(_vm.totalSpace))
                              )
                            ])
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.unTips.includes(_vm.cloudName) &&
                  !_vm.emailClouds.includes(_vm.cloudName) &&
                  _vm.driveType != "Icedrive"
                    ? _c(
                        "el-tab-pane",
                        { attrs: { label: _vm.tips, name: "second" } },
                        [
                          _vm.driveType != "NAS"
                            ? _c("div", {
                                staticClass: "tip-content",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup." +
                                        _vm.cloudName +
                                        "Tips"
                                    )
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.driveType == "NAS"
                            ? _c("div", {
                                staticClass: "tip-content",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "language.popup.addCloudPopup.FTPTips"
                                    )
                                  )
                                }
                              })
                            : _vm._e()
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cloudName == "iCloudPhotos" ||
                  _vm.cloudName == "iCloudDrive"
                    ? _c(
                        "el-tab-pane",
                        { attrs: { label: _vm.tips, name: "second" } },
                        [
                          _c("div", {
                            staticClass: "tip-content",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "language.popup.addCloudPopup.iCloudPhotosTips"
                                )
                              )
                            }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cloudName == "fourShared"
                    ? _c(
                        "el-tab-pane",
                        { attrs: { label: _vm.tips, name: "second" } },
                        [
                          _c("div", {
                            staticClass: "tip-content",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "language.popup.addCloudPopup.fourSharedTips"
                                )
                              )
                            }
                          })
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a31a2b86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a31a2b86","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/add_cloud_popups/properties_popup.vue
// module id = null
// module chunks = 